// extracted by mini-css-extract-plugin
export default {"tile":"styles_tile__FfhH1"};